
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"47","height":"34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_11272_1158)"}},[_c('path',{attrs:{"d":"M14.385 15.692C14.385 7.026 21.312 0 29.858 0h1.663c8.545 0 15.473 7.026 15.473 15.692v2.602c0 8.666-6.928 15.692-15.473 15.692h-1.663c-8.546 0-15.473-7.026-15.473-15.692v-2.602z","fill":"url(#paint0_linear_11272_1158)"}}),_c('path',{attrs:{"d":"M38.637 16.627a.44.44 0 010 .732L25.386 26.04a.43.43 0 01-.663-.366V8.312a.43.43 0 01.663-.366l13.251 8.681z","fill":"#fff"}}),_c('path',{attrs:{"d":"M18.887 13.053H7.341a.433.433 0 00-.43.436v.113c0 .24.193.436.43.436h11.546c.238 0 .43-.195.43-.436v-.113a.433.433 0 00-.43-.436z","fill":"#EDEEFF"}}),_c('path',{attrs:{"d":"M11.976 17.516H.43a.433.433 0 00-.43.436v.113c0 .241.192.436.43.436h11.546c.237 0 .43-.195.43-.436v-.113a.433.433 0 00-.43-.436z","fill":"#F4B9FF"}}),_c('path',{attrs:{"d":"M18.887 21.98H7.341a.433.433 0 00-.43.436v.113c0 .24.193.436.43.436h11.546c.238 0 .43-.195.43-.436v-.113a.433.433 0 00-.43-.436z","fill":"#EDEEFF"}})]),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_11272_1158","x1":"46.994","y1":"16.993","x2":"14.385","y2":"16.993","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#F9BAFF"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#B9A9FF"}})]),_c('clipPath',{attrs:{"id":"clip0_11272_1158"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h47v34H0z"}})])])])
          )
        }
      }
    